import React from 'react';
import { useParams } from 'react-router-dom';
import Craps from '../games/Craps';
import Roulette from '../games/Roulette';
import { useTokens } from '../components/TokenContext';
import Slots from "../games/Slots";
import Slots2 from '../games/Slots2';
import Slots3 from '../games/Slots3';
import Races from '../games/Races';
import WheelOfFortune from "../games/WheelOfFortune";
//import BlackJack from '../games/blackjack/BlackJack';
import LuckyNumber from '../games/LuckyNumber';
import Crash from '../games/Crash';

const gamesMap = {
    craps: <Craps />,
    roulette: <Roulette />,
    slots: <Slots />,
    slots2: <Slots2 />,
    slots3: <Slots3 />,
    races: <Races/>,
    wheel: <WheelOfFortune/>,
    crash: <Crash/>,
    //blackjack: <BlackJack/>,
    luckynumber: <LuckyNumber/>
};

function GameLoader() {
    const { name } = useParams();
    const { tokens } = useTokens();

    const gameComponent = gamesMap[name.toLowerCase()];

    return (
        <div className="game-container">
            <div className="tokens-display">
                Casino Coins: {tokens}
            </div>
            {gameComponent || <h1>Hra nebyla nalezena</h1>}
        </div>
    );
}

export default GameLoader;
